import { TranslationKey } from '@amusnet/translations'
import { useTranslation } from '@amusnet/translations/react'
import React from 'react'

type FeatureDescriptionProps = {
    className: string
    textColor: string
    textStrokeColor: string
    textShadowColor: string
    localizationKey: TranslationKey
}

export const FeatureDescription: React.FC<FeatureDescriptionProps> = (props) => {
    const { t } = useTranslation()

    const { className, textColor, textStrokeColor, textShadowColor, localizationKey } = props

    return (
        <div
            className={className}
            style={{
                color: textColor,
                paintOrder: 'stroke fill',
                filter: `drop-shadow(0 3px 0 ${textShadowColor})`,
                WebkitTextStroke: `2px ${textStrokeColor}`,
            }}
        >
            {t(localizationKey)}
        </div>
    )
}
